import { createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/images/cursor_left_bottom.png'
import _imports_1 from '@/assets/images/search_icon.png'


const _hoisted_1 = { class: "pantry-recipe-search-view" }
const _hoisted_2 = { class: "pantry-recipe-search-view-header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-recipe-search-view-back-image",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "commonSearchInputViewArea pantry-recipe-search-view-input-area" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "pantry-recipe-search-view-input-icon-area" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "commonSearchIcon pantry-recipe-search-view-input-icon",
    src: _imports_1
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "pantry-recipe-search-view-search-text" }, "検索", -1)
const _hoisted_7 = { class: "pantry-recipe-search-view-list-view" }
const _hoisted_8 = { class: "pantry-recipe-search-view-list-view_item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryFoodItem = _resolveComponent("PantryFoodItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: "pantry-recipe-search-view-back-view",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickBack(...args)))
      }, [
        _hoisted_3
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createVNode("input", {
        ref: "textInput",
        class: "pantry-recipe-search-view-input-text",
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.keywordComputed = $event)),
        placeholder: "レシピや食材で検索する",
        enterkeyhint: "done",
        onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.handleEnter()), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.keywordComputed]
      ]),
      _createVNode("div", {
        class: "pantry-recipe-search-view-search-text-view",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickSearch(...args)))
      }, [
        _hoisted_6
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _withDirectives(_createVNode("div", _hoisted_8, [
        _createVNode("div", {
          class: "pantry-recipe-search-view-list-view-input",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickFood(...args)))
        }, _toDisplayString(_ctx.inputItem), 1)
      ], 512), [
        [_vShow, _ctx.isShowInputItem]
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getList(), (item, index) => {
        return (_openBlock(), _createBlock(_component_PantryFoodItem, {
          key: index,
          foodId: item.foodId,
          name: item.name,
          icon: item.icon,
          recipeFoodItem: item.recipeFoodItem,
          onSelectFood: _ctx.selectFood
        }, null, 8, ["foodId", "name", "icon", "recipeFoodItem", "onSelectFood"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}